module.exports = __webpack_public_path__ + "img/cloudpro.b6e5ec89.jpg";